// extracted by mini-css-extract-plugin
export default {"header":"OnboardingHeader_header__jTFBD","stepper":"OnboardingHeader_stepper__TgFra"};